export const environment = {
  production: false,
  preprod: false,
  authMode: "keycloak" as "keycloak" | "mock",
  secretKey: "8085dc3b-19e6-4158-81f1-156228d15858",
  keycloak: {
    issuer: "https://identity.lokos.in/",
    realm: "lokos",
    clientId: "web-console",
    scope: "openid profile email",
  },
  keyClockApiBaseUrl: "https://admin.lokos.in/",
  keyclockCdnUrl: "https://cdn.lokos.in/keycloak/",
  profilesApiBaseUrl: "https://apis.lokos.in/profiles/",
  profilesStateShortCode: "CG",
  apiBaseUrl: "https://api.lokos.in/",
  clfApiBaseUrl: "https://mclfdev.lokos.in/",
  cadreSubscriptionKey: "",
  reportSubscriptionKey: "",
  ocpApimSubscriptionKey: "",
  keyClockSubscriptionKey: "af33e1a7aeaf40b68326f85d7ba85a1f",
  lokosSubscriptionKey: "7511f1a237fa45898f255dd4a52b2282",
  profileSubscriptionKey: "4e08fd38ca984ad0b3257f38195b8276",
  enableEncryption: true,
  mclfToggleBaseUrl: "https://stage-fdm.lokos.in/api/profiles/v3/lokos-profile",
  fdmIntegrationBaseUrl: "https://stage-fdm.lokos.in/api/fdm/v1/fdm-integration",
  fdmSubscriptionKey: "5598bad5185c48efb912531c1fd18dcd",
};

